<script>
  import MarketingOverviewNewDesign from "./MarketingOverviewNewDesign.svelte";
  import LandSelect from "./LandSelect.svelte";
  import SourceCatSelect from "./SourceCatSelect.svelte";
  import { onMount } from "svelte";
  import jQuery from "jquery";
  import { calc_or4_block, calc_or4_block_boundaries, calc_or4_block_conversions, insights_bearbeiten } from "./OrFourChartUtils.svelte";
  import { create_bar_chart_dataset, lead_link, seperate_per_month } from "./OrThreeChartUtils.svelte";
  import {
    get_date_text_from_selected_time_frame,
    get_date_text_table_from_selected_time_frame,
    month_to_number,
    number_to_month,
    remove_dataimport_except_when_opportunity,
  } from "./Utils.svelte";

  window.jQuery = jQuery;
  window.$ = jQuery;

  export let show_main_content;
  export let show_link;
  export let u_n;

  export let res_partner_all;
  export let crm_lead_all;
  export let start_get_marketing_data;
  export let marketing_team;
  export let lost_leads;
  export let lost_opportunities;
  export let insights;
  export let sale_order_all;
  export let marketing_goals;
  export let sales_goals;
  export let messenger_res;
  export let subscription_all;
  export let activated_all;
  export let helptexts;
  export let in_show_helptext_id;

  export let archived;
  export let goals_all;

  export let laender_dict;

  export let date_start_string_month = "Jan";
  export let date_end_string_month = number_to_month(new Date().getMonth());
  export let date_start_string_year = new Date().getFullYear().toString();
  export let date_end_string_year = new Date().getFullYear().toString();

  let selected_timeframe_text = "";
  let selected_timeframe_text_table = "";
  let sales_goals_per_month;

  let ytd_active = true;
  let filter_active = false;

  let country_list_default = ["Germany", "Austria", "Switzerland", "UK", "USA", "NZ/AUS", "BENELUX", "ROW"];
  let country_list_original;

  export let marketing_start_date = new Date(new Date().getFullYear(), 0, 1);
  export let marketing_end_date = new Date();
  let marketing_start_date_compare;
  let marketing_end_date_compare;

  let follower_chart;
  let reichweite_chart;

  let recalc_marketing_new_design = false;

  let progress;

  let include_dataimport = false;

  let country_dict = {
    Germany: "Germany",
    Austria: "Austria",
    Switzerland: "Switzerland",
    "United Kingdom": "UK",
    "United States": "USA",
    "New Zealand": "NZ/AUS",
    Australia: "NZ/AUS",
    Belgium: "BENELUX",
    Netherlands: "BENELUX",
    Luxembourg: "BENELUX",
    rest: "ROW",
  };

  let source_cat_dict = [
    { long: "Advertising", short: "Advertising (ADV)", checked: true },
    { long: "Events", short: "Events (EVT)", checked: true },
    { long: "Organic", short: "Organic (ORG)", checked: true },
    { long: "Sales", short: "Sales (SAL)", checked: true },
  ];

  let chart_names = [
    "Lead Since",
    "MQL Total",
    "MQL Lost",
    "MQL Won",
    "MQL Open",
    "SQL Total",
    "SQL Lost",
    "SQL Won",
    "SQL Open",
    "Opportunities total",
    "Opportunities Won",
    "Opportunities Lost",
    "Opportunities (MQL) total",
    "Opportunities (MQL) Won",
    "Opportunities (MQL) Lost",
    "Opportunities (SQL) total",
    "Opportunities (SQL) Won",
    "Opportunities (SQL) Lost",
    "Conversion lead to opportunity in days total",
    "Conversion Opportunity to customer in days Won",
  ];
  let chart_name = "Lead Since";

  let show_index = 0;

  let selected_from_lead_since = new Date();
  let selected_to_lead_since = new Date();
  let filter_lead_since_count = 0;
  let filter_lead_since_table_data;

  let crm_lead_and_opportunities_filtered;
  let total_leads;
  let mql_total;
  let mql_lost;
  let mql_won;
  let mql_open;
  let sql_total;
  let sql_lost;
  let sql_won;
  let sql_open;
  let all_leads_open;

  let lost_all_original;
  let lost_all_filtered;

  let opportunities_from_mql_total;
  let opportunities_from_mql_lost;
  let opportunities_from_mql_won;

  let opportunities_from_sql_total;
  let opportunities_from_sql_lost;
  let opportunities_from_sql_won;

  let opportunities_total;
  let opportunities_won;
  let opportunities_lost;

  let only_one_time_adjust_countries = true;

  let nr_active_boli_calculated_from_messenger_events = 0;

  // FILTER
  let source_selected = "";
  let source_list;
  let country_list;
  let country_selected = "";
  let sales_person_selected = "";
  let sales_person_list;
  let campaign_selected = "";
  let campaign_list;

  // CHART DATA:
  let redraw;
  let salesman_selected = "";
  let lead_days_bar_chart_data;
  let chart_total_leads = {};
  let chart_mql_total = {};
  let chart_mql_lost = {};
  let chart_mql_won = {};
  let chart_mql_open = {};
  let chart_sql_total = {};
  let chart_sql_lost = {};
  let chart_sql_won = {};
  let chart_sql_open = {};
  let chart_opportunities_total = {};
  let chart_opportunities_won = {};
  let chart_opportunities_lost = {};
  let chart_opportunities_mql_total = {};
  let chart_opportunities_mql_won = {};
  let chart_opportunities_mql_lost = {};
  let chart_opportunities_sql_total = {};
  let chart_opportunities_sql_won = {};
  let chart_opportunities_sql_lost = {};
  let chart_conversion_lead_to_opportunities = {};
  let chart_conversion_opportunities_to_customer = {};
  let insight_table_data = {};

  let crm_lead_all_without_data_import;
  let lost_leads_without_data_import;
  let lost_opportunities_without_data_import;
  let archived_without_data_import;

  const options = [
    {
      value: "y",
      label: "year",
    },
    {
      value: "m",
      label: "month",
    },
    {
      value: "d",
      label: "day",
    },
  ];

  let all_total_leads;
  let first_loaded = true;

  $: {
    marketing_team, crm_lead_all, lost_leads, sales_goals, lost_opportunities, marketing_goals, messenger_res, subscription_all;

    if (
      marketing_team &&
      crm_lead_all &&
      lost_leads &&
      sales_goals &&
      lost_opportunities &&
      marketing_goals &&
      messenger_res &&
      subscription_all
    ) {
      let tmp_without_data_import = remove_dataimport_except_when_opportunity(crm_lead_all, lost_leads, lost_opportunities, archived);

      crm_lead_all_without_data_import = tmp_without_data_import["crm_lead_all"];
      lost_leads_without_data_import = tmp_without_data_import["lost_leads"];
      lost_opportunities_without_data_import = tmp_without_data_import["lost_opportunities"];
      archived_without_data_import = tmp_without_data_import["archived"];

      // console.log('archived_without_data_import: ', archived_without_data_import);

      // console.log('lost_opportunities_without_data_import: ', lost_opportunities_without_data_import);
      // console.log('lost_leads_without_data_import: ', lost_leads_without_data_import);
      // console.log('crm_lead_all_without_data_import: ', crm_lead_all_without_data_import);

      lost_all_original = lost_leads_without_data_import.concat(lost_opportunities_without_data_import);

      all_total_leads = lost_all_original.concat(crm_lead_all_without_data_import);

      sales_goals_per_month = seperate_per_month(sales_goals, "start_date");

      // console.log("lost_leads_without_data_import: ", lost_leads_without_data_import)
      // console.log("lost_opportunities_without_data_import: ", lost_opportunities_without_data_import)

      // console.log("marketing_team: ", marketing_team)
      if (marketing_team.includes(u_n)) {
        show_link = true;
        // console.log("show_link wird true")
      }

      if (!first_loaded) {
        console.log("do_all_calculations Marketing: ", insights);
        do_all_calculations();
      }

      if (first_loaded) {
        get_multiselect_filter();
        first_loaded = false;
        filter();
      }
    }
  }

  $: {
    marketing_start_date;
    marketing_end_date;
    laender_dict;

    if (marketing_start_date && marketing_end_date) {
      if (marketing_start_date <= marketing_end_date) {
        filter();
        selected_timeframe_text = get_date_text_from_selected_time_frame(marketing_start_date, marketing_end_date);

        selected_timeframe_text_table = get_date_text_table_from_selected_time_frame(marketing_start_date, marketing_end_date);
      } else {
        alert("Start Date after End Date");
      }
    }
  }

  // get_insights();

  // async function get_insights() {
  //   getByUrlWithThen(get_ip_address_prefix() + '/rest/api_dashboard_dataframe/insights/').then((response) =>
  //     response.json().then(async function (data) {
  //       insights = data['data_json'];

  //       console.log('insights: ', insights);
  //       console.log('insights loaded.');
  //     })
  //   );
  // }

  // $: {
  //   source_selected, country_selected, sales_person_selected, campaign_selected;

  //   if (source_selected.length > 0 || country_selected.length > 0 || sales_person_selected.length || campaign_selected.length) {
  //     if (!first_events_from_select) {
  //       do_all_calculations();
  //     } else {
  //       first_events_from_select = first_events_from_select - 1;
  //     }
  //   }
  // }

  $: {
    chart_name;
    if (chart_name) {
      // console.log("chart_names: ", chart_names)
      // console.log("chart_name: ", chart_name)

      let index = findIndexInArray(chart_names, chart_name);
      // console.log("index: ", index)
      set_index_to(index);
    }
  }

  onMount(() => {
    jSuites.calendar(document.getElementById("calendar1"), {
      type: "year-month-picker",
      format: "MMM-YYYY",
      validRange: ["2020-01-01", "2030-12-31"],
    });
    jSuites.calendar(document.getElementById("calendar2"), {
      type: "year-month-picker",
      format: "MMM-YYYY",
      validRange: ["2020-01-01", "2030-12-31"],
    });

    // document.getElementById('calendar1').addEventListener("change", myFunction);

    // var collection = document.getElementsByClassName("jcalendar-month")[0].addEventListener("change", myFunction);

    window
      .$("#calendar1div")
      .find(".jcalendar-month")
      .on("DOMSubtreeModified", function (e) {
        //Do calculation and change value of other span2,span3 here
        date_start_string_month = e.target.outerText;
      });
    window
      .$("#calendar1div")
      .find(".jcalendar-year")
      .on("DOMSubtreeModified", function (e) {
        //Do calculation and change value of other span2,span3 here
        date_start_string_year = e.target.outerText;
      });
    window
      .$("#calendar2div")
      .find(".jcalendar-month")
      .on("DOMSubtreeModified", function (e) {
        //Do calculation and change value of other span2,span3 here
        date_end_string_month = e.target.outerText;
      });
    window
      .$("#calendar2div")
      .find(".jcalendar-year")
      .on("DOMSubtreeModified", function (e) {
        //Do calculation and change value of other span2,span3 here
        date_end_string_year = e.target.outerText;
      });

    // window.$('.jcalendar-year').on('DOMSubtreeModified', function (e) {
    //   //Do calculation and change value of other span2,span3 here
    //   console.log('CHANGE input!', e['outerText']);
    // });

    // jcalendar-input
  });

  function findIndexInArray(array, element) {
    var index = 0;
    var found = -1;
    array.forEach((a) => {
      // console.log("a: ", a)
      // console.log("element: ", element)
      if (element == a) {
        found = index;
      }
      index = index + 1;
    });
    return found;
  }

  async function do_all_calculations() {
    // console.log("crm_lead_all_without_data_import: ", crm_lead_all_without_data_import)

    console.log("Do all Calcutlations");

    lost_all_filtered = lost_all_original;

    if (insights) {
      let tmp = insights_bearbeiten(
        insights,
        marketing_start_date,
        marketing_end_date,
        marketing_start_date_compare,
        marketing_end_date_compare,
      );
      insight_table_data = tmp["table"];

      follower_chart = tmp["follower_chart"];
      reichweite_chart = tmp["reichweite_chart"];
    }

    filter_all();

    seperate_leads();

    calc_lead_since();

    calc_charts_mql_sql();

    redraw = true;
  }

  function calc_charts_mql_sql() {
    // console.log("mql_lost: ",mql_lost)

    chart_total_leads = calc_or4_block(
      total_leads,
      "create_date",
      marketing_start_date,
      marketing_end_date,
      marketing_start_date_compare,
      marketing_end_date_compare,
    );

    chart_mql_total = calc_or4_block(
      mql_total,
      "create_date",
      marketing_start_date,
      marketing_end_date,
      marketing_start_date_compare,
      marketing_end_date_compare,
    );
    chart_mql_lost = calc_or4_block(
      mql_lost,
      "date_closed",
      marketing_start_date,
      marketing_end_date,
      marketing_start_date_compare,
      marketing_end_date_compare,
    );
    chart_mql_won = calc_or4_block(
      mql_won,
      "date_last_stage_update",
      marketing_start_date,
      marketing_end_date,
      marketing_start_date_compare,
      marketing_end_date_compare,
    );

    chart_mql_open = calc_or4_block_boundaries(
      mql_total,
      "create_date",
      "date_closed",
      marketing_start_date,
      marketing_end_date,
      marketing_start_date_compare,
      marketing_end_date_compare,
    );

    chart_sql_total = calc_or4_block(
      sql_total,
      "create_date",
      marketing_start_date,
      marketing_end_date,
      marketing_start_date_compare,
      marketing_end_date_compare,
    );
    chart_sql_lost = calc_or4_block(
      sql_lost,
      "date_closed",
      marketing_start_date,
      marketing_end_date,
      marketing_start_date_compare,
      marketing_end_date_compare,
    );
    chart_sql_won = calc_or4_block(
      sql_won,
      "date_last_stage_update",
      marketing_start_date,
      marketing_end_date,
      marketing_start_date_compare,
      marketing_end_date_compare,
    );
    chart_sql_open = calc_or4_block_boundaries(
      sql_total,
      "create_date",
      "date_closed",
      marketing_start_date,
      marketing_end_date,
      marketing_start_date_compare,
      marketing_end_date_compare,
    );

    chart_opportunities_total = calc_or4_block(
      opportunities_total,
      "create_date",
      marketing_start_date,
      marketing_end_date,
      marketing_start_date_compare,
      marketing_end_date_compare,
    );
    chart_opportunities_won = calc_or4_block(
      opportunities_won,
      "partner__first_order_date",
      marketing_start_date,
      marketing_end_date,
      marketing_start_date_compare,
      marketing_end_date_compare,
    );
    chart_opportunities_lost = calc_or4_block(
      opportunities_lost,
      "date_closed",
      marketing_start_date,
      marketing_end_date,
      marketing_start_date_compare,
      marketing_end_date_compare,
    );

    chart_opportunities_mql_total = calc_or4_block(
      opportunities_from_mql_total,
      "create_date",
      marketing_start_date,
      marketing_end_date,
      marketing_start_date_compare,
      marketing_end_date_compare,
    );
    chart_opportunities_mql_won = calc_or4_block(
      opportunities_from_mql_won,
      "partner__first_order_date",
      marketing_start_date,
      marketing_end_date,
      marketing_start_date_compare,
      marketing_end_date_compare,
    );
    chart_opportunities_mql_lost = calc_or4_block(
      opportunities_from_mql_lost,
      "date_closed",
      marketing_start_date,
      marketing_end_date,
      marketing_start_date_compare,
      marketing_end_date_compare,
    );

    chart_opportunities_sql_total = calc_or4_block(
      opportunities_from_sql_total,
      "create_date",
      marketing_start_date,
      marketing_end_date,
      marketing_start_date_compare,
      marketing_end_date_compare,
    );
    chart_opportunities_sql_won = calc_or4_block(
      opportunities_from_sql_won,
      "partner__first_order_date",
      marketing_start_date,
      marketing_end_date,
      marketing_start_date_compare,
      marketing_end_date_compare,
    );
    chart_opportunities_sql_lost = calc_or4_block(
      opportunities_from_sql_lost,
      "date_closed",
      marketing_start_date,
      marketing_end_date,
      marketing_start_date_compare,
      marketing_end_date_compare,
    );

    chart_conversion_lead_to_opportunities = calc_or4_block_conversions(
      opportunities_total,
      "create_date",
      "date_conversion",
      "lead_to_opportunity",
      marketing_start_date,
      marketing_end_date,
      marketing_start_date_compare,
      marketing_end_date_compare,
    );

    chart_conversion_opportunities_to_customer = calc_or4_block_conversions(
      opportunities_total,
      "date_conversion",
      "date_last_stage_update",
      "opportunity_to_customer",
      marketing_start_date,
      marketing_end_date,
      marketing_start_date_compare,
      marketing_end_date_compare,
      "stage_id",
      "Gewonnen",
    );

    // console.log('chart_opportunities_sql_lost: ', chart_opportunities_sql_lost);
    console.log("chart_conversion_opportunities_to_customer: ", chart_conversion_opportunities_to_customer);
    // chart_conversion_opportunities_to_customer =
  }

  function seperate_leads() {
    // bei den totalen fehlen noch die lost einträge
    let mql_total_tmp = [];
    let mql_lost_tmp = [];
    let mql_won_tmp = [];
    let mql_open_tmp = [];
    let sql_total_tmp = [];
    let sql_lost_tmp = [];
    let sql_won_tmp = [];
    let sql_open_tmp = [];
    let total_leads_tmp = [];

    let opportunities_from_mql_total_tmp = [];
    let opportunities_from_mql_lost_tmp = [];
    let opportunities_from_mql_won_tmp = [];

    let opportunities_from_sql_total_tmp = [];
    let opportunities_from_sql_lost_tmp = [];
    let opportunities_from_sql_won_tmp = [];

    var sql_sources = ["Cold call/cold visit/persönliche Recherche", "Data Import", "Existing Customer"];

    // console.log('lost_leads_without_data_import: ', lost_leads_without_data_import);
    // console.log('lost_all_filtered: ', lost_all_filtered);
    lost_all_filtered.forEach((element) => {
      var element_standardisieren = {
        active: element["x_active"],
        date_closed: element["x_date_closed"],
        lost_reason: element["lost_reason"],
        x_name: element["x_name"],
        display_name: element["display_name"],
        create_date: element["x_date_creation"],
        source: element["x_source"],
        won_status: element["x_status_won"],
        type: element["x_type"],
        user_id: element["x_user_id"],
        country: element["country"],
        user: element["x_user_id"] ? element["x_user_id"][1] : false,
        campaign: element["campaign"] ? element["campaign"] : false,
      };

      total_leads_tmp.push(element_standardisieren);

      if (element["x_type"] == "opportunity") {
        if (sql_sources.includes(element["x_source"])) {
          // if(element['x_source'] != "Data Import"){
          //     console.log("element['x_source']: ", element['x_source'])
          // }

          /*  if(element_standardisieren['country'] == "Germany"){
            if(element_standardisieren['create_date'].substring(0,7) == "2021-04"){
                console.log("111april 2021-04: ", element_standardisieren)
            }
        }*/

          opportunities_from_sql_lost_tmp.push(element_standardisieren);
          opportunities_from_sql_total_tmp.push(element_standardisieren);
          sql_total_tmp.push(element_standardisieren);
          sql_lost_tmp.push(element_standardisieren);
        } else {
          /*if(element_standardisieren['country'] == "Germany"){
            if(element_standardisieren['create_date'].substring(0,7) == "2021-04"){
                console.log("LOST 2021-04: ", element_standardisieren)
            }
        }*/

          opportunities_from_mql_total_tmp.push(element_standardisieren);
          opportunities_from_mql_lost_tmp.push(element_standardisieren);
          // console.log("mql_total_tmp hinzu: ", element_standardisieren)
          mql_total_tmp.push(element_standardisieren);
          mql_lost_tmp.push(element_standardisieren);
        }
      } else {
        if (sql_sources.includes(element["x_source"])) {
          /*if(element_standardisieren['country'] == "Germany"){
            if(element_standardisieren['create_date'].substring(0,7) == "2021-04"){
                console.log("333april 2021-04: ", element_standardisieren)
            }
        }*/

          sql_total_tmp.push(element_standardisieren);
          sql_lost_tmp.push(element_standardisieren);
        } else {
          /*if(element_standardisieren['country'] == "Germany"){
            if(element_standardisieren['create_date'].substring(0,7) == "2021-04"){
                console.log("LOST 2021-04: ", element_standardisieren)
            }
        }*/

          mql_total_tmp.push(element_standardisieren);
          mql_lost_tmp.push(element_standardisieren);
        }
      }
    });

    // console.log('crm_lead_and_opportunities_filtered: ', crm_lead_and_opportunities_filtered);
    crm_lead_and_opportunities_filtered.forEach((element) => {
      total_leads_tmp.push(element);

      if (element["type"] == "opportunity") {
        if (element["source_id"]) {
          if (element["source_id"][1]) {
            element["source"] = element["source_id"][1];

            if (element["campaign_id"]) {
              element["campaign"] = element["campaign_id"][1];
            }
            if (element["user_id"]) {
              element["user"] = element["user_id"][1];
            }

            if (element["partner__first_order_date"]) {
              if (element["partner__first_order_date"] == "False") {
                element["partner__first_order_date"] = false;
              }
            }

            if (sql_sources.includes(element["source_id"][1])) {
              opportunities_from_sql_total_tmp.push(element);
              // sql_total_tmp.push(element);
              if (element["date_last_stage_update"] && (element["stage_id"][1] == "Closing" || element["stage_id"][1] == "Gewonnen")) {
                opportunities_from_sql_won_tmp.push(element);
              }

              //ALT:
              // if (element['partner__first_order_date']) {
              //   opportunities_from_sql_won_tmp.push(element);
              // }
            } else {
              opportunities_from_mql_total_tmp.push(element);
              // mql_total_tmp.push(element);
              //ALT:
              // if (element['partner__first_order_date']) {
              //   opportunities_from_mql_won_tmp.push(element);
              // }
              if (element["date_last_stage_update"] && (element["stage_id"][1] == "Closing" || element["stage_id"][1] == "Gewonnen")) {
                opportunities_from_mql_won_tmp.push(element);
              }
            }
          }
        }
      }

      if (element["source_id"]) {
        if (element["source_id"][1]) {
          element["source"] = element["source_id"][1];

          if (element["campaign_id"]) {
            element["campaign"] = element["campaign_id"][1];
          }
          if (element["user_id"]) {
            element["user"] = element["user_id"][1];
          }

          if (element["partner__first_order_date"]) {
            if (element["partner__first_order_date"] == "False") {
              element["partner__first_order_date"] = false;
            }
          }

          if (sql_sources.includes(element["source_id"][1])) {
            sql_total_tmp.push(element);

            if (!element["date_closed"]) {
              sql_open_tmp.push(element);
            }

            //ALT:
            // if (element['partner__first_order_date']) {
            //   sql_won_tmp.push(element);
            // }

            if (element["date_last_stage_update"] && (element["stage_id"][1] == "Closing" || element["stage_id"][1] == "Gewonnen")) {
              sql_won_tmp.push(element);
            }
          } else {
            //if(element['country'] == "Germany"){
            //   if(element['create_date'].substring(0,7) == "2021-04"){
            //       console.log("2021-04: ", element)
            //   }
            //}

            mql_total_tmp.push(element);

            if (!element["date_closed"]) {
              mql_open_tmp.push(element);
            }

            //ALT:
            // if (element['partner__first_order_date']) {
            //   mql_won_tmp.push(element);
            // }

            if (element["date_last_stage_update"] && (element["stage_id"][1] == "Closing" || element["stage_id"][1] == "Gewonnen")) {
              mql_won_tmp.push(element);
            }
          }
        }
      }
    });

    // console.log("mql_total_tmp: ", mql_total_tmp)

    mql_total = mql_total_tmp;
    mql_lost = mql_lost_tmp;
    mql_won = mql_won_tmp;
    mql_open = mql_open_tmp;
    sql_total = sql_total_tmp;
    sql_lost = sql_lost_tmp;
    sql_won = sql_won_tmp;
    sql_open = sql_open_tmp;
    total_leads = total_leads_tmp;

    // console.log('total_leads in MIRROR:', total_leads);

    all_leads_open = sql_open.concat(mql_open);

    opportunities_from_mql_total = opportunities_from_mql_total_tmp;
    opportunities_from_mql_lost = opportunities_from_mql_lost_tmp;
    opportunities_from_mql_won = opportunities_from_mql_won_tmp;

    opportunities_from_sql_total = opportunities_from_sql_total_tmp;
    opportunities_from_sql_lost = opportunities_from_sql_lost_tmp;
    opportunities_from_sql_won = opportunities_from_sql_won_tmp;

    opportunities_total = opportunities_from_mql_total_tmp.concat(opportunities_from_sql_total_tmp);
    opportunities_won = opportunities_from_mql_won_tmp.concat(opportunities_from_sql_won_tmp);
    opportunities_lost = opportunities_from_mql_lost_tmp.concat(opportunities_from_sql_lost_tmp);

    // crm_lead_and_opportunities_filtered.forEach((element) => {
    //   if (element['name'] == 'Messelead Betrieb Haider Josef') {
    //     console.log('element: ', element);
    //   }
    // });

    // console.log('mql_total: ', mql_total);
    // console.log('mql_lost: ', mql_lost);
    // console.log('mql_won: ', mql_won);
    // console.log('mql_open: ', mql_open);
    // console.log('sql_total: ', sql_total);
    // console.log('sql_lost: ', sql_lost);
    // console.log('sql_won: ', sql_won);
    // console.log('sql_open: ', sql_open);

    // console.log('opportunities_from_mql_total: ', opportunities_from_mql_total);
    // console.log('opportunities_from_mql_lost: ', opportunities_from_mql_lost);
    // console.log('opportunities_from_mql_won: ', opportunities_from_mql_won);
    // console.log('opportunities_from_sql_total: ', opportunities_from_sql_total);
    // console.log('opportunities_from_sql_lost: ', opportunities_from_sql_lost);
    // console.log('opportunities_from_sql_won: ', opportunities_from_sql_won);
  }

  function get_multiselect_filter() {
    source_list = [];
    country_list = country_list_default;
    sales_person_list = [];
    campaign_list = [];
    country_list_original = [];

    lost_all_original.forEach((element) => {
      if (!country_list_original.includes(element["country"])) {
        country_list_original.push(element["country"]);
      }
    });

    crm_lead_all_without_data_import.forEach((element) => {
      if (element[1]["source_id"]) {
        if (element[1]["source_id"][1]) {
          if (!source_list.includes(element[1]["source_id"][1])) {
            source_list.push(element[1]["source_id"][1]);
          }
        }
      }
      if (element[1]["country"]) {
        if (!country_list_original.includes(element[1]["country"])) {
          country_list_original.push(element[1]["country"]);
        }
      }

      if (element[1]["user_id"]) {
        if (!sales_person_list.includes(element[1]["user_id"][1])) {
          sales_person_list.push(element[1]["user_id"][1]);
        }
      }

      if (element[1]["campaign_id"]) {
        if (!campaign_list.includes(element[1]["campaign_id"][1])) {
          campaign_list.push(element[1]["campaign_id"][1]);
        }
      }
    });

    source_selected = source_list;
    // country_selected = country_list;
    // sales_person_selected = sales_person_list;
    // campaign_selected = campaign_list;
  }

  function filter_all() {
    // CRM:

    var tmp_crm_lead_filtered = [];

    // console.log('crm_lead_all_without_data_import: ', crm_lead_all_without_data_import);

    crm_lead_all_without_data_import.forEach((element) => {
      tmp_crm_lead_filtered.push(element[1]);
    });
    crm_lead_and_opportunities_filtered = tmp_crm_lead_filtered;

    lost_all_filtered = lost_all_original;

    adjust_countries();

    filter_sources();
    filter_countries();
    filter_sales_persons();
    filter_campaings();
  }

  function set_ytd() {
    marketing_start_date = new Date(new Date().getFullYear(), 0, 1);
    marketing_end_date = new Date();
    ytd_active = true;
    filter_active = false;
  }

  function adjust_countries() {
    if (only_one_time_adjust_countries) {
      let i = 0;
      for (i = 0; i < crm_lead_and_opportunities_filtered.length; i++) {
        var obj = crm_lead_and_opportunities_filtered[i];
        //country

        // crm_lead_and_opportunities_filtered[i]['original_country'] = crm_lead_and_opportunities_filtered[i]['country']

        if (obj["country"] in country_dict) {
          crm_lead_and_opportunities_filtered[i]["country"] = country_dict[obj["country"]];
          // if(country_dict[obj['country']] != 'Germany' && country_dict[obj['country']] != 'Austria'){
          //     console.log("obj['country']: ", obj['country'])
          // }
        } else {
          crm_lead_and_opportunities_filtered[i]["country"] = country_dict["rest"];
        }
      }
      for (i = 0; i < lost_all_filtered.length; i++) {
        var obj = lost_all_filtered[i];
        //country
        if (obj["country"] in country_dict) {
          lost_all_filtered[i]["country"] = country_dict[obj["country"]];
        } else {
          lost_all_filtered[i]["country"] = country_dict["rest"];
        }
      }

      //  console.log("adjust_countries")
      // console.log("crm_lead_and_opportunities_filtered: ", crm_lead_and_opportunities_filtered)
      // console.log("lost_all_filtered: ", lost_all_filtered)
      only_one_time_adjust_countries = false;
    }
  }

  function filter_campaings() {
    var tmp_crm_lead_filtered = [];

    // console.log('crm_lead_and_opportunities_filtered: ', crm_lead_and_opportunities_filtered);

    if (campaign_selected.length > 0) {
      crm_lead_and_opportunities_filtered.forEach((element) => {
        if (campaign_selected.includes(element["campaign_id"][1])) {
          tmp_crm_lead_filtered.push(element);
        }
      });

      crm_lead_and_opportunities_filtered = tmp_crm_lead_filtered;

      var tmp_lost = [];
      lost_all_filtered.forEach((element) => {
        if (element["x_campaign_id"]) {
          if (campaign_selected.includes(element["x_campaign_id"][1])) {
            tmp_lost.push(element);
          }
        }
      });
      lost_all_filtered = tmp_lost;
    }
  }

  function filter_sales_persons() {
    var tmp_crm_lead_filtered = [];

    // console.log('crm_lead_and_opportunities_filtered: ', crm_lead_and_opportunities_filtered);

    if (sales_person_selected.length > 0) {
      crm_lead_and_opportunities_filtered.forEach((element) => {
        if (sales_person_selected.includes(element["user_id"][1])) {
          tmp_crm_lead_filtered.push(element);
        }
      });

      crm_lead_and_opportunities_filtered = tmp_crm_lead_filtered;

      var tmp_lost = [];
      lost_all_filtered.forEach((element) => {
        if (sales_person_selected.includes(element["x_user_id"][1])) {
          tmp_lost.push(element);
        }
      });
      lost_all_filtered = tmp_lost;
    }
  }

  function filter_sources() {
    var tmp_crm_lead_filtered = [];

    //Filter Source/Source excluded
    if (source_selected.length > 0) {
      // console.log("kommt rein")
      crm_lead_and_opportunities_filtered.forEach((element) => {
        if (source_selected.includes(element["source_id"][1])) {
          tmp_crm_lead_filtered.push(element);
        }
      });
      crm_lead_and_opportunities_filtered = tmp_crm_lead_filtered;

      var tmp_lost = [];
      lost_all_filtered.forEach((element) => {
        if (source_selected.includes(element["x_source"])) {
          tmp_lost.push(element);
        }
      });
      lost_all_filtered = tmp_lost;
    }
  }

  function filter_countries() {
    var tmp_crm_lead_filtered = [];

    var tmp_crm_lead_lost_filtered = [];
    // console.log("source_selected: ", source_selected)

    // Filter Country
    if (country_selected.length > 0) {
      crm_lead_and_opportunities_filtered.forEach((element) => {
        if (country_selected.includes(element["country"])) {
          tmp_crm_lead_filtered.push(element);
        }
      });
      crm_lead_and_opportunities_filtered = tmp_crm_lead_filtered;

      lost_all_filtered.forEach((element) => {
        if (country_selected.includes(element["country"])) {
          tmp_crm_lead_lost_filtered.push(element);
        }
      });
      lost_all_filtered = tmp_crm_lead_lost_filtered;
    }
  }

  function calc_lead_since() {
    // 'create_date'

    var today = new Date();

    var count_hist = {
      "<=3": 0,
      ">3": 0,
      ">7": 0,
      ">30": 0,
      ">90": 0,
      ">120": 0,
      ">365": 0,
    };

    all_leads_open.forEach((element) => {
      if (!element["create_date"]) {
        return;
      }

      var date = new Date(element["create_date"]);
      var Difference_In_Time = today.getTime() - date.getTime();
      var days = Math.round(Difference_In_Time / (1000 * 3600 * 24));
      // console.log("Difference_In_Days: ", days)

      if (days <= 3) {
        count_hist["<=3"] = count_hist["<=3"] + 1;
      }
      if (days > 3 && days <= 7) {
        count_hist[">3"] = count_hist[">3"] + 1;
      }
      if (days > 7 && days <= 30) {
        count_hist[">7"] = count_hist[">7"] + 1;
      }
      if (days > 30 && days <= 90) {
        count_hist[">30"] = count_hist[">30"] + 1;
      }
      if (days > 90 && days <= 120) {
        count_hist[">90"] = count_hist[">90"] + 1;
      }
      if (days > 120 && days <= 365) {
        count_hist[">120"] = count_hist[">120"] + 1;
      }
      if (days > 365) {
        count_hist[">365"] = count_hist[">365"] + 1;
      }
    });

    var labels = ["<=3", ">3", ">7", ">30", ">90", ">120", ">365"];

    var values = [];

    labels.forEach((e) => {
      values.push(count_hist[e]);
    });

    lead_days_bar_chart_data = create_bar_chart_dataset(labels, values, "");
    // console.log("lead_days_bar_chart_data: ", lead_days_bar_chart_data)
  }

  async function filter() {
    recalc_marketing_new_design = false;
    recalc_marketing_new_design = true;

    /* TODO WIEDER EINKOMMENTIEREN. ALTES ZEUG
    // console.log('progress start');
    progress.start();
    do_all_calculations();
    // console.log('progress complete');
    progress.complete();
    redraw = false;
    redraw = true;
    */
  }

  function set_index_to(index) {
    show_index = index;
  }

  function update_date_filter() {
    var date_start = new Date(parseInt(date_start_string_year), month_to_number(date_start_string_month), 1, 0, 0, 0);
    var date_end = new Date(parseInt(date_end_string_year), month_to_number(date_end_string_month) + 1, 0, 23, 59);

    marketing_start_date = date_start;
    marketing_end_date = date_end;

    ytd_active = false;
    filter_active = true;
  }
</script>

<!-- <div class="row flex {show_main_content === true ? 'div' : 'hiddenClass'}">
  <MarketingOverview {all_total_leads} {country_list_original} />
</div> -->

<nav class="navbar navbar-expand navbar-light navbar-bg {show_main_content === true ? 'div' : 'hiddenClass'}">
  <div class="col">
    <div class="row flex">
      <div class="row">
        <div class="col-12">
          <div class="">
            <div class="">
              <div class="row" style="height:110px;">
                <div class="col-2" style="margin-left:-20px;">
                  <b style="white-space: nowrap;">SELECTION CRITERIA&nbsp;&nbsp;&nbsp;</b>
                </div>

                <div class="col-5" style="margin-left:-70px;">
                  <table>
                    <tr>
                      <!--  <td><h5 class="card-title" style="font-size: 10px;">Select Timeframe:&nbsp; &nbsp;</h5></td> -->

                      <td style="text-align:center; width:20%;"><b>Select timeframe: </b></td>

                      <td style="text-align:center; width:10%;"
                        ><div on:click={set_ytd} class="btn {ytd_active ? 'active' : ''}">
                          <nobr>YTD {new Date().getFullYear()}</nobr>
                        </div></td
                      >

                      <td style="text-align:right; width:15%; padding-right:10px;"><b>From:</b></td>
                      <td style="text-align:center; width:15%;"
                        ><div id="calendar1div">
                          <input class="month-year" value="Jan-01" id="calendar1" style="color: black;" />
                        </div></td
                      >
                      <td style="text-align:right; width:15%; padding-right:10px;"><b>To:</b></td>
                      <td style="text-align:center; width:15%;"
                        ><div id="calendar2div">
                          <input class="month-year" id="calendar2" value="YTD" style="color: black;" />
                        </div></td
                      >
                      <td style="text-align:center; width:10%;  padding-left:10px;">
                        <div class="btn small-btn {filter_active ? 'active' : ''}" style="font-size: 10px;" on:click={update_date_filter}>
                          Filter
                        </div>
                      </td>
                    </tr>
                  </table>

                  <!-- <DatePickerText is_compare={false} bind:start_date={marketing_start_date} bind:end_date={marketing_end_date} /> -->
                </div>

                <div class="col-3 trenner-links" style="margin-left:70px;">
                  <div class="row">
                    <div class="col-1" />
                    <div class="col-10">
                      <b style="white-space: nowrap; margin-left:0px; margin-bottom:20px;">Select lead countries:</b>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-2" />
                    <div class="col-10">
                      <LandSelect bind:laender_dict />
                    </div>
                  </div>
                </div>

                <div class="col-2 trenner-links" style="margin-left:20px;">
                  <b class="form-check-label" style="white-space: nowrap; margin-left:20px; margin-bottom:20px;"
                    >Select source categories:</b
                  >
                  <SourceCatSelect bind:source_cat_dict />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</nav>

<!-- <div class="container">

</div> -->
<main class={show_main_content === true ? "content div" : "hiddenClass"} style="padding: 5px;">
  <MarketingOverviewNewDesign
    {ytd_active}
    bind:recalc={recalc_marketing_new_design}
    {marketing_start_date}
    {marketing_end_date}
    {all_total_leads}
    {res_partner_all}
    {sale_order_all}
    {include_dataimport}
    {marketing_goals}
    {sales_goals}
    {selected_timeframe_text}
    {selected_timeframe_text_table}
    {u_n}
    {start_get_marketing_data}
    {marketing_team}
    crm_lead_all={crm_lead_all_without_data_import}
    lost_leads={lost_leads_without_data_import}
    lost_opportunities={lost_opportunities_without_data_import}
    {insights}
    archived={archived_without_data_import}
    {goals_all}
    {messenger_res}
    {subscription_all}
    {activated_all}
    bind:source_cat_dict
    bind:laender_dict
    bind:nr_active_boli_calculated_from_messenger_events
    {helptexts}
    {in_show_helptext_id}
  />

  <!-- <div class="container-fluid p-0">
    <InsightsBlock data={insight_table_data} {follower_chart} {reichweite_chart} {redraw} />

    <MarketingBlock data={chart_total_leads} {redraw} title="Total Leads:" />
    <MarketingBlock data={chart_mql_total} {redraw} title="MQL Total:" />
    <MarketingBlock data={chart_mql_lost} {redraw} title="MQL Lost:" />
    <MarketingBlock data={chart_mql_won} {redraw} title="MQL Won:" />
    <MarketingBlock data={chart_mql_open} {redraw} title="MQL Open:" />

    <MarketingBlock data={chart_sql_total} {redraw} title="SQL Total" />
    <MarketingBlock data={chart_sql_lost} {redraw} title="SQL Lost" />
    <MarketingBlock data={chart_sql_won} {redraw} title="SQL Won" />
    <MarketingBlock data={chart_sql_open} {redraw} title="SQL Open" />

    <MarketingBlock data={chart_opportunities_total} {redraw} title="Opportunities Total" />
    <MarketingBlock data={chart_opportunities_won} {redraw} title="Opportunities Won" />
    <MarketingBlock data={chart_opportunities_lost} {redraw} title="Opportunities Lost" />
    <MarketingBlock data={chart_opportunities_mql_total} {redraw} title="Opportunities to MQL Total" />
    <MarketingBlock data={chart_opportunities_mql_won} {redraw} title="Opportunities to MQL Won" />
    <MarketingBlock data={chart_opportunities_mql_lost} {redraw} title="Opportunities to MQL Lost" />
    <MarketingBlock data={chart_opportunities_sql_total} {redraw} title="Opportunities to SQL Total" />
    <MarketingBlock data={chart_opportunities_sql_won} {redraw} title="Opportunities to SQL Won" />
    <MarketingBlock data={chart_opportunities_sql_lost} {redraw} title="Opportunities to SQL Lost" />

    <MarketingBlock data={chart_conversion_lead_to_opportunities} {redraw} title="Covnersion Lead To Opportunities" />
    <MarketingBlock data={chart_conversion_opportunities_to_customer} {redraw} title="Covnersion Opportunities To Customers
" /> -->

  <!-- THIS PART NEEDS TO BE COMMENTED IN EXTRA (BZW AUSGELASSEN) {#if show_index == 0}
      <div class="row">
        &nbsp;<br />
        <h4>Lead Since</h4>
        <div class="mb-0">
          <span class="text" />
        </div>
      </div>

      <div class="row">
        <div class="col-md-6 col-xl-6">
          <div class="card flex-fill">
            <div class="card-header">
              <h5 class="card-title mb-0" />
              {#if lead_days_bar_chart_data}
                <Bar data={lead_days_bar_chart_data} />
              {/if}
            </div>
          </div>
        </div>
        <div class="col-md-6 col-xl-6">
          <div class="card flex-fill">
            <div class="card-header">
              <h5 class="card-title mb-0">Select Interval</h5>

              <div class="row">
                <div class="col">
                  <b>From</b>
                  <DatePicker
                    formattedSelectedEnd={false}
                    end={new Date()}
                    bind:selected={selected_from_lead_since}
                    format={'#{F} #{j}, #{Y}'}
                  />
                </div>
                <div class="col">
                  <b>To</b>

                  <DatePicker
                    formattedSelectedEnd={false}
                    end={new Date()}
                    bind:selected={selected_to_lead_since}
                    format={'#{F} #{j}, #{Y}'}
                  />
                </div>
                <div class="col">
                  <div class="py-2">&nbsp;</div>
                  <div class="btn btn-primary" on:click={filter_lead_since}>Filter</div>
                </div>
                {#if filter_lead_since_count && filter_lead_since_table_data}
                  <div class="row"><b>Open Leads: </b> &nbsp; {filter_lead_since_count}</div>

                  <CollapsibleSection headerText={'Show Leads'}>
                    <div class="content">
                      <Table columns={filter_lead_since_table_data['columns']} data={filter_lead_since_table_data['values']} />
                    </div>
                  </CollapsibleSection>
                {/if}
              </div>
            </div>
          </div>
        </div>
      </div>
    {/if} -->

  <!--   </div> -->
</main>

<style>
  .month-year {
    width: 100px;
    border: grey 0.25pt solid;
    border-radius: 5px;
    font-size: 12px;
  }

  .trenner-links {
    border-left: 3px solid #d9d9d9;
  }

  .half {
    width: 50px;
  }

  .hiddenClassGaunt {
    visibility: hidden;
  }

  .hiddenClass {
    visibility: hidden;
    display: none;
  }
  .help {
    position: absolute;
    right: 0;
    top: 0;
    width: 22px;
    height: 15px;
    z-index: 100;
  }
  .funnel {
    max-width: 100%;
  }

  .funnelParentNumbers {
    display: flex;
    flex-direction: column;
  }

  .flex-2 {
    position: relative;
    flex: 1;
  }
  .flex-2-child {
    display: flex;
    align-items: stretch;
    height: 16.8%;
  }

  .gauge_boli {
    width: 100%;
  }

  #sold_more_then_boli {
    width: 50px;
    height: 20px;
    background: #268026;
    border-width: 2px;
    border-style: solid;
    border-color: grey;
  }

  #current_boli {
    width: 50px;
    height: 20px;
    background: #fff04d;
    border-width: 2px;
    border-style: solid;
    border-color: grey;
  }

  #should_be_here {
    width: 50px;
    height: 20px;
    background: #03fcf4;
    border-width: 2px;
    border-style: solid;
    border-color: grey;
  }

  .reddiv {
    width: 50px;
    height: 20px;
    background: #990e05;
    border-width: 2px;
    border-style: solid;
    border-color: grey;
  }

  .greendiv {
    width: 50px;
    height: 20px;
    background: #268026;
    border-width: 2px;
    border-style: solid;
    border-color: grey;
  }

  .active {
    color: #333;
    border-color: #325cff;
  }

  .vertical-center {
    margin: 0;
    position: absolute;
    top: 50%;
    -ms-transform: translateY(-50%);
    transform: translateY(-50%);
  }

  main {
    /*background-color: #c5e0b4;*/
  }
</style>
